import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'pivotFields',
})

export class PivotFieldsPipe implements PipeTransform {

    transform(pivotFields:any[], aggregateFuction: any,countOptions:any[]):any {
        if(aggregateFuction){
            if(aggregateFuction == 'count'){
                return countOptions;
            }else{
                return pivotFields;
            }
        }else{
            return [];
        }
    }
}